import { Tooltip } from "@/components/ui/tooltip";
import { CounterDeliveryEntity } from "@/pages/grain-requests/counter-delivery/schema/counter-delivery.schema";
import { AppColors } from "@/styles/colors";
import { Flex, Text } from "@chakra-ui/react";
import { Eye } from "lucide-react";

interface Props {
  item: CounterDeliveryEntity;
  handleDetail: (id: any) => void;
}

export const CounterDeliveryActions = ({
  handleDetail,
  item,
}: Props) => {
  //Acciones para contra entrega
  return (
    <Tooltip
      openDelay={500}
      closeDelay={100}
      positioning={{ placement: "left" }}
      content={<Text fontSize="14px">Ver detalle</Text>}
      contentProps={{
        css: {
          paddingX: "10px",
          "--tooltip-bg": AppColors.GREEN_PRIMARY,
        },
      }}
    >
      <Flex position="relative">
        <Eye
          cursor="pointer"
          onClick={() => handleDetail(item?.id)}
          data-testid="counter-delivery-actions-eye"
        />
      </Flex>
    </Tooltip>
  );
};
